<template>
	<div style="height: 98%;" class="parent">
		<div class="crumbs mcrumb-self">
			<el-breadcrumb separator="-">
				<el-breadcrumb-item>
					<i class="el-icon-files"></i><span>档案采集</span>
				</el-breadcrumb-item>
				<el-breadcrumb-item><span>文件查看</span></el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- <el-divider></el-divider> -->
		<div class="container">
			<el-tabs v-model="voucherViewTabs">
				<el-tab-pane label="记账凭证" name="1">
					<div style="display: flex;padding-top: 12px;">
						<div style="width: 60px;margin-right: 15px;line-height: 37px;"><label style="color: #606266;">文件状态</label></div>
						<div class="voucher-img-div" v-for="(imgObj, index) in accVoucherFileStatusImgList" :key="index">
							<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="($event) => fileStatusImgClickFun($event, index, 'accVoucherFileStatusImgList')">
						</div>
					</div>
					<div>
						<el-checkbox v-model="vh_checked" @change="changeVhAll">全选</el-checkbox>
					</div>
					<el-divider></el-divider>
					<div style="line-height: 35px;">
						<el-row>
							<el-col :span="10">
								<!-- <el-button plain style="width: 80px;padding: 5px 15px;vertical-align: middle;"><i class="el-icon-arrow-up" style="font-size: 20px;font-weight: bold;"></i></el-button>
								<el-button plain style="width: 80px;padding: 5px 15px;vertical-align: middle;"><i class="el-icon-arrow-down" style="font-size: 20px;font-weight: bold;"></i></el-button> -->
								<!-- <el-button type="primary" @click="updateFileLevelClickFun()">文件密级修改</el-button> -->
								<el-button plain style="width: 80px;" @click="deleteVoucherFileClickFun()">删除</el-button>
							</el-col>
							<el-col :span="14" style="text-align: right;">
								<el-button style="margin-right:15px;border: none;font-size: 14px;" plain icon="el-icon-search" @click="advanceQuery()">高级筛选</el-button>
								<el-input v-model="accVoucherDataSearchName" placeholder="凭证号码、凭证金额、所属实体" style="width:350px;margin-bottom:5px" prefix-icon="el-icon-search" @keyup.native="fuzzyQueryVoucherData"/>
							</el-col>
						</el-row>
					</div>
					<div style="margin-top: 5px;">
						<div style="display: flex;">
							<div style="width: 75%;">
								<el-table ref="accVoucherTable" :data="accVoucherTableData" border stripe class="table" height="520px" @row-click="(row, column, event) => clickRowByChecked('accVoucherTable', row, column, event)" @cell-mouse-enter="showVoucherImg" @cell-mouse-leave="closeVoucherImg" :highlight-current-row="true">
									<el-table-column type="selection" width="55" align="center"></el-table-column>
									<el-table-column prop="id" v-if="showColumn == true"></el-table-column>
									<el-table-column prop="voucherType" label="凭证类型" align="center" width="100">
										<template>
											<div v-for="(imgObj, index) in formatAccVoucherTypeImgList" :key="index">
												<img :src="require('../../../assets/img/' + imgObj.name+ '.png')">
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="voucherNo" label="凭证号码" sortable align="center">
										<!-- <template slot-scope="scoped">
											<el-popover trigger="click" placement="right-start" :ref="'popover' + scoped.row.voucherNo" @show="showAccPopover">
												<div style="width: 800px;height: 480px;"  v-if="previewFlag">
													<accvoucher v-bind:accvoucherId="scoped.row.id" v-bind:previewFlag="previewFlag" style="width: 98%;"></accvoucher>
												</div>
												<div slot="reference">
													<p class="text" style="cursor: pointer;">{{ scoped.row.voucherNo }}</p>
												</div>
											</el-popover>
										</template> -->
									</el-table-column>
									<el-table-column prop="amount" label="凭证金额" sortable align="center" :formatter="(row, column, cellValue, index) => formatAmountSeparator(cellValue)"></el-table-column>
									<el-table-column prop="voucherDate" label="凭证日期" sortable align="center" :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
									<el-table-column prop="companyName" label="所属实体" sortable align="center"></el-table-column>
									<el-table-column prop="fileLevel" label="文件密级" width="100" sortable align="center">
										<template slot-scope="scoped">
											<span v-if="scoped.row.fileLevel != '*'">{{scoped.row.fileLevel}}级</span>
											<span v-else>{{scoped.row.fileLevel}}</span>
										</template>
									</el-table-column>
									<el-table-column prop="fileStatus" label="文件状态" align="center" width="90">
										<template slot-scope="scoped">
											<div v-for="(imgObj, index) in formatFileStatusImgList" :key="index">
												<img v-if="scoped.row.fileStatus == imgObj.code" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="year" label="财年" sortable align="center"></el-table-column>
									<el-table-column prop="operate" label="操作" width="90" align="center">
										<template slot-scope="scoped">
											<el-button size="small" type="text" @click="viewVoucherDetailsClickFun(scoped.row)">查看更多</el-button>
										</template>
									</el-table-column>
								</el-table>
								<div class="pagination">
									<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
									<el-pagination
										@size-change="(val) => handleSizeChange('accvoucherpwm', val)"
										@current-change="(val) => handleCurrentChange('accvoucherpwm', val)"
										:current-page="accvoucherpwm.page"
										:page-size="accvoucherpwm.limit"
										:page-sizes="accvoucherpwm.limits"
										layout="total, sizes, prev, pager, next, jumper"
										:total="accvoucherpwm.count">
									</el-pagination>
								</div>
							</div>
							<div style="width: 25%;">
								<el-card class="box-card" style="height: 520px;margin-left:20px;overflow-y: auto;">
									<el-form :model="accVoucherUploadInfoForm">
										<span class="voucher-tag-title" style="font-size: 16px;line-height: 30px;">查看详情</span>
										<div style="padding-top: 5px;">
											<span class="voucher-tag-title">上传信息</span>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">原文件名：{{accVoucherUploadInfoForm.fileName}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">批次号：{{accVoucherUploadInfoForm.batchNo}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">文件号：{{accVoucherUploadInfoForm.fileNo}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">上传人：{{accVoucherUploadInfoForm.operator}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">上传时间：{{this.timestampSecondFormatter(accVoucherUploadInfoForm.importTime, '')}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">导入方式：{{this.formatImportWay('', '', accVoucherUploadInfoForm.importWay, '')}}</span>
											</el-row>
										</div>
										<div style="padding-top: 5px;">
											<span class="voucher-tag-title">组内列表</span>
											<div class="block" style="padding-top: 10px;padding-left: 5px;">
												<el-timeline>
													<el-timeline-item
														v-for="(recordObj, index) in accVoucherUploadInfoForm.opRecordList"
														:key="index"
														:icon="recordObj.icon"
														:type="recordObj.type"
														:color="recordObj.color"
														size="large"
														:hide-timestamp="true">
														<!-- #0bbd87 -->
														<div style="display: flex;line-height: 20px;">
															<div v-for="(typeObj, index) in formatFileStatusImgList" :key="index">
																<span v-if="typeObj.code == recordObj.opType">{{typeObj.title}}</span>    
															</div>
															<span style="padding-left: 8px;">{{recordObj.opTime}}</span>
															<span style="padding-left: 8px;">{{recordObj.operator}}</span>
														</div>
														<el-link v-if="recordObj.groupNo" :underline="false" type="primary" style="line-height: 30px;" @click="viewGroupDetailsClickFun(recordObj.id)"> 组号：{{ recordObj.groupNo }}</el-link>
														<el-link v-if="recordObj.bookNo" :underline="false"  type="primary" style="line-height: 30px;" @click="viewVolumeDetailsClickFun(recordObj.id)">册号：{{ recordObj.bookNo }}</el-link>
													</el-timeline-item>
												</el-timeline>
											</div>
										</div>
									</el-form>
								</el-card>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="原始凭证" name="2">
					<div style="display: flex;">
						<div style="width: 60px;margin-right: 15px;line-height: 37px;"><label style="color: #606266;">凭证类型</label></div>
						<div class="voucher-img-div" v-for="(imgObj, index) in oriVoucherTypeImgList" :key="index">
							<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="voucherTypeImgClickFun($event, index)">
						</div>
					</div>
					<div>
						<el-checkbox v-model="pz_checked" @change="changePzAll">全选</el-checkbox>
					</div>
					<div style="display: flex;padding-top: 12px;">
						<div style="width: 60px;margin-right: 15px;line-height: 37px;"><label style="color: #606266;">文件状态</label></div>
						<div class="voucher-img-div" v-for="(imgObj, index) in oriVoucherFileStatusImgList" :key="index">
							<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="($event) => fileStatusImgClickFun($event, index, 'oriVoucherFileStatusImgList')">
						</div>
					</div>
					<div>
						<el-checkbox v-model="fiChecked"  @change="changeFiAll">全选</el-checkbox>
					</div>
					<el-divider></el-divider>
					<div style="line-height: 35px;">
						<el-row>
							<el-col :span="10">
								<!-- <el-button plain style="width: 80px;padding: 5px 15px;vertical-align: middle;" @click="upRow('oriVoucherTable')"><i class="el-icon-arrow-up" style="font-size: 20px;font-weight: bold;"></i></el-button>
								<el-button plain style="width: 80px;padding: 5px 15px;vertical-align: middle;" @click="downRow('oriVoucherTable')"><i class="el-icon-arrow-down" style="font-size: 20px;font-weight: bold;"></i></el-button> -->
								<!-- <el-button type="primary" @click="updateFileLevelClickFun()">文件密级修改</el-button> -->
								<!-- <el-button plain style="width: 80px;" @click="deleteVoucherFileClickFun()">删除</el-button> -->
							</el-col>
							<el-col :span="14" style="text-align: right;">
								<el-button style="margin-right:15px;border: none;font-size: 14px;" plain icon="el-icon-search" @click="advanceQuery">高级筛选</el-button>
								<el-input v-model="oriVoucherDataSearchName" placeholder="凭证号码、凭证金额、所属实体" style="width:350px;margin-bottom:5px" prefix-icon="el-icon-search" @keyup.native="fuzzyQueryVoucherData"/>
							</el-col>
						</el-row>
					</div>
					<div style="margin-top: 5px;">
						<div style="display: flex;">
							<div style="width: 75%;">
								<el-table ref="oriVoucherTable" :data="oriVoucherTableData" border stripe class="table" height="520px" @row-click="(row, column, event) => clickRowByChecked('oriVoucherTable', row, column, event)" @cell-mouse-enter="showVoucherImg" @cell-mouse-leave="closeVoucherImg" :row-class-name="tableRowClassName" :highlight-current-row="true">
									<el-table-column type="selection" width="55" align="center"></el-table-column>
									<el-table-column type="index" v-if="showColumn == true"></el-table-column>
									<el-table-column prop="id" v-if="showColumn == true"></el-table-column>
									<el-table-column prop="voucherType" label="凭证类型" align="center" width="100">
										<template slot-scope="scoped">
											<div v-for="(imgObj, index) in formatOriVoucherTypeImgList" :key="index">
												<img v-if="scoped.row.voucherType == imgObj.code" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="processNo" label="流程号" sortable align="center"></el-table-column>
									<el-table-column prop="voucherNo" label="凭证号码" sortable align="center">
										<!-- <template slot-scope="scoped">
											<el-popover trigger="click" placement="right-start" :ref="'popover' + scoped.row.voucherNo">
												<div style="width: 800px;height: 600px;">
													<img v-if="scoped.row.fileType == 'png' || scoped.row.fileType == 'jpg'" :src="imgBaseUrl + '/archival/getOriginalVoucherDataById?id=' + scoped.row.id + '&' + tokenParam" width="98%" height="98%" style="margin: 5px auto;">
													<iframe v-if="scoped.row.fileType == 'pdf'" :src="imgBaseUrl + '/archival/getOriginalVoucherDataById?id=' + scoped.row.id + '&'+ tokenParam" width="98%" height="98%" frameborder="no" scrolling="yes" style="overflow-y:scroll;"></iframe>
													<iframe v-if="scoped.row.fileType == 'ofd'" :src="ofdReaderPath + '/ofd/reader?file=' + imgBaseUrl + '/archival/getOriginalVoucherDataById?id=' + scoped.row.id + '%26' + tokenParam" width="100%" height="98%" frameborder="no" scrolling="yes" style="overflow-y:scroll;"></iframe>
												</div>
												<div slot="reference">
													<p class="text" style="cursor: pointer;">{{ scoped.row.voucherNo }}</p>
												</div>
											</el-popover>
										</template> -->
									</el-table-column>
									<el-table-column prop="amount" label="凭证金额" sortable align="center" :formatter="(row, column, cellValue, index) => formatAmountSeparator(cellValue)"></el-table-column>
									<el-table-column prop="voucherDate" label="凭证日期" sortable align="center" :formatter="(row, column, cellValue, index) => this.timestampFormatter(cellValue)"></el-table-column>
									<el-table-column prop="companyName" label="所属实体" sortable align="center"></el-table-column>
									<el-table-column prop="fileLevel" label="文件密级" sortable width="120" align="center">
										<template slot-scope="scoped">
											<span v-if="scoped.row.fileLevel != '*'">{{scoped.row.fileLevel}}级</span>
											<span v-else>{{scoped.row.fileLevel}}</span>
										</template>
									</el-table-column>
									<el-table-column prop="fileStatus" label="文件状态" align="center" width="100">
										<template slot-scope="scoped">
											<div v-for="(imgObj, index) in formatFileStatusImgList" :key="index">
												<img v-if="scoped.row.fileStatus == imgObj.code" :src="require('../../../assets/img/' + imgObj.name+ '.png')">
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="operate" label="操作" width="120" align="center">
										<template slot-scope="scoped">
											<el-button size="small" type="text" @click="viewVoucherDetailsClickFun(scoped.row)">查看更多</el-button>
										</template>
									</el-table-column>
								</el-table>
								<div class="pagination">
									<el-link :underline="false" style="float: right;font-size: 20px;font-size:20px;margin: 7px 0px 0px 20px;" icon="el-icon-refresh" @click="refresh()"></el-link>
									<el-pagination
										@size-change="(val) => handleSizeChange('orivoucherpwm', val)"
										@current-change="(val) => handleCurrentChange('orivoucherpwm', val)"
										:current-page="orivoucherpwm.page"
										:page-size="orivoucherpwm.limit"
										:page-sizes="orivoucherpwm.limits"
										layout="total, sizes, prev, pager, next, jumper"
										:total="orivoucherpwm.count">
									</el-pagination>
								</div>
							</div>
							<div style="width: 25%;">
								<el-card class="box-card" style="height: 520px;margin-left:20px;overflow-y: auto;">
									<el-form :model="oriVoucherUploadInfoForm">
										<span class="voucher-tag-title" style="font-size: 16px;line-height: 30px;">查看详情</span>
										<div style="padding-top: 5px;">
											<span class="voucher-tag-title">上传信息</span>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">原文件名：{{oriVoucherUploadInfoForm.fileName}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">批次号：{{oriVoucherUploadInfoForm.batchNo}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">文件号：{{oriVoucherUploadInfoForm.fileNo}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">上传人：{{oriVoucherUploadInfoForm.operator}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">上传时间：{{this.timestampSecondFormatter(oriVoucherUploadInfoForm.importTime)}}</span>
											</el-row>
											<el-row style="line-height: 25px;">
												<span class="voucher-tag-contmg">导入方式：{{this.formatImportWay('', '', oriVoucherUploadInfoForm.importWay, '')}}</span>
											</el-row>
										</div>
										<div style="padding-top: 5px;">
											<span class="voucher-tag-title">组内列表</span>
											<div class="block" style="padding-top: 10px;padding-left: 5px;">
												<el-timeline>
													<el-timeline-item
														v-for="(recordObj, index) in oriVoucherUploadInfoForm.opRecordList"
														:key="index"
														:icon="recordObj.icon"
														:type="recordObj.type"
														:color="recordObj.color"
														size="large"
														:hide-timestamp="true">
														<!-- #0bbd87 -->
														<div style="display: flex;line-height: 20px;">
															<div v-for="(typeObj, index) in formatFileStatusImgList" :key="index">
																<span v-if="typeObj.code == recordObj.opType">{{typeObj.title}}</span>
															</div>
															<span style="padding-left: 8px;">{{recordObj.opTime}}</span>
															<span style="padding-left: 8px;">{{recordObj.operator}}</span>
														</div>
														<el-link v-if="recordObj.groupNo" :underline="false" type="primary" style="line-height: 30px;" @click="viewGroupDetailsClickFun(recordObj.id)"> 组号：{{ recordObj.groupNo }}</el-link>
														<el-link v-if="recordObj.bookNo" :underline="false"  type="primary" style="line-height: 30px;" @click="viewVolumeDetailsClickFun()">册号：{{ recordObj.bookNo }}</el-link>
													</el-timeline-item>
												</el-timeline>
											</div>
										</div>
									</el-form>
								</el-card>
							</div>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>

			<el-dialog title="高级筛选" :visible.sync="advanceQueryDialogVisible" width="60%">
				<div class="custom-dialog">
					<el-form :model="archivesViewQueryForm" ref="archivesViewQueryRefForm" style="width: 98%;">
						<div style="margin-bottom: 15px;">
							<span class="ac-title">凭证内容</span>
							<div style="margin: 10px 0px 0px 0px;">
								<el-row type="flex" v-show="voucherViewTabs == 1">
									<el-col :span="3" class="ac-form-label" style="line-height: 37px;">凭证类型</el-col>
									<el-col :span="4">
										<el-select v-model="archivesViewQueryForm.sapType" placeholder="-- 请选择 --">
											<el-option
												v-for="item in selectOptions"
												:key="item.value"
												:label="item.label"
												:value="item.value">
											</el-option>
										</el-select>
									</el-col>
								</el-row>
								<el-row type="flex" v-show="voucherViewTabs == 2">
									<el-col :span="3" class="ac-form-label" style="line-height: 37px;">凭证类型</el-col>
									<el-col :span="21">
										<div class="ac-form-input" style="display: flex;">
											<div class="voucher-img-div" v-for="(imgObj, index) in oriVoucherTypeImgList" :key="index">
												<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="voucherTypeImgDiglogClickFun($event, index)">
											</div>
										</div>
										<div>
											<el-checkbox v-model="advanceVChecked" @change="changeadvanceVAll">全选</el-checkbox>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex" style="margin-top: 12px;">
									<el-col :span="3"  class="ac-form-label">流程号</el-col>
									<el-col :span="9">
										<div class="ac-form-input">
											<el-input v-model="archivesViewQueryForm.processNo" placeholder="单行输入" ></el-input>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex" style="margin-top: 12px;">
									<el-col :span="3"  class="ac-form-label">凭证号码</el-col>
									<el-col :span="9">
										<div class="ac-form-input">
											<el-input v-model="archivesViewQueryForm.pzhm" placeholder="单行输入" ></el-input>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex" style="margin-top: 15px;">
									<el-col :span="3" class="ac-form-label">凭证金额</el-col>
									<el-col :span="9">
										<div class="ac-form-input" style="display: flex;">
											<el-input v-model="archivesViewQueryForm.jshjStart"  placeholder="最小金额"></el-input>
											<span> - </span>
											<el-input v-model="archivesViewQueryForm.jshjEnd"  placeholder="最大金额"></el-input>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex" style="margin-top: 15px;">
									<el-col :span="3" class="ac-form-label">凭证日期</el-col>
									<el-col :span="9">
										<div class="ac-form-input" style="display: flex;">
											<el-date-picker v-model="archivesViewQueryForm.pzrqStart" type="date" placeholder="开始日期" value-format="yyyy-MM-dd"></el-date-picker>
											<span> - </span>
											<el-date-picker v-model="archivesViewQueryForm.pzrqEnd" type="date" placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex" style="margin-top: 15px;">
									<el-col :span="3" class="ac-form-label" style="line-height: 37px;">文件状态</el-col>
									<el-col :span="21">
										<div class="ac-form-input" style="display: flex;" v-if="voucherViewTabs == 2">
											<div class="voucher-img-div" v-for="(imgObj, index) in oriVoucherFileStatusImgList" :key="index">
												<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="fileStatusImgDialogClickFun($event, index, 'oriVoucherFileStatusImgList')">
											</div>
										</div>
										<div class="ac-form-input" style="display: flex;" v-if="voucherViewTabs == 1">
											<div class="voucher-img-div" v-for="(imgObj, index) in accVoucherFileStatusImgList" :key="index">
												<img :title=imgObj.title :src="require('../../../assets/img/' + imgObj.name+ '.png')"  :name=imgObj.name @click="fileStatusImgDialogClickFun($event, index, 'accVoucherFileStatusImgList')">
											</div>
										</div>
										<div>
											<el-checkbox v-model="advanceChecked"  @change="advanceAll">全选</el-checkbox>
										</div>
									</el-col>
								</el-row>
							</div>
						</div>
						<div style="margin-bottom: 15px;">
							<span class="ac-title">文件信息</span>
							<div style="margin: 10px 0px 0px 0px;">
								<el-row type="flex" style="margin-top: 15px;">
									<el-col :span="3" class="ac-form-label">文件号</el-col>
									<el-col :span="9">
										<div class="ac-form-input">
											<el-input v-model="archivesViewQueryForm.wjh" placeholder="单行输入" ></el-input>
										</div>
									</el-col>
									<el-col :span="3" class="ac-form-label">批次号</el-col>
									<el-col :span="9">
										<div class="ac-form-input">
											<el-input v-model="archivesViewQueryForm.pch" placeholder="单行输入" ></el-input>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex" style="margin-top: 15px;">
									<el-col :span="3" class="ac-form-label">上传人</el-col>
									<el-col :span="9">
										<div class="ac-form-input">
											<el-input v-model="archivesViewQueryForm.scr" placeholder="单行输入" ></el-input>
										</div>
									</el-col>
									<el-col :span="3" class="ac-form-label">原文件名</el-col>
									<el-col :span="9">
										<div class="ac-form-input">
											<el-input v-model="archivesViewQueryForm.ywjm" placeholder="单行输入" ></el-input>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex" style="margin-top: 15px;">
									<el-col :span="3" class="ac-form-label">上传时间</el-col>
									<el-col :span="9">
										<div class="ac-form-input" style="display: flex;">
											<el-date-picker v-model="archivesViewQueryForm.scsjStart" type="date" placeholder="开始时间" value-format="yyyy-MM-dd"></el-date-picker>
											<span> - </span>
											<el-date-picker v-model="archivesViewQueryForm.scsjEnd" type="date" placeholder="结束时间" value-format="yyyy-MM-dd"></el-date-picker>
										</div>
									</el-col>
								</el-row>
								<el-row type="flex" style="margin-top: 15px;">
									<el-col :span="3" class="ac-form-label">文件密级</el-col>
									<el-col :span="21">
										<div class="ac-form-input">
											<el-checkbox-group v-model="fileLevelList"  style="line-height: 32px;">
												<el-checkbox label="1">1级 - 绝密</el-checkbox>
												<el-checkbox label="2">2级 - 机密</el-checkbox>
												<el-checkbox label="3">3级 - 秘密</el-checkbox>
												<el-checkbox label="4">4级 - 一般</el-checkbox>
												<el-checkbox label="5">5级 - 公开</el-checkbox>
											</el-checkbox-group>
										</div>
									</el-col>
								</el-row>
							</div>
						</div>
						<div style="text-align: center;margin-top: 15px;">
							<el-button type="primary" style="width: 80px;margin-right: 100px;" @click="search('archivesViewQueryRefForm')">筛选</el-button>
							<el-button style="width: 80px;" @click="resetForm('archivesViewQueryRefForm')">重置</el-button>
						</div>
					</el-form>
				</div>
			</el-dialog>

			<!-- 文件密级修改 dialog -->
			<el-dialog title="密级修改" :visible.sync="fileLevelDialogVisible" width="25%" top="40vh" :close-on-click-modal="false">
				<div class="custom-dialog" style="height: 130px;">
					<el-form :model="secretLevelForm">
						<div style="line-height: 35px;">当前共选中<span style="color: #409EFF;padding: 0px 5px;">{{secretLevelForm.count}}</span>份文件，</div>
						<div style="line-height: 35px;">
							<span>密级统一修改为</span>
							<el-input v-if="showColumn == true" v-model="secretLevelForm.voucherIds"></el-input>
							<el-select v-model="secretLevelForm.fileLevel" placeholder="请选择" style="width: 150px;padding: 0px 10px;" @change="fileLevelSelectChange">
								<el-option v-for="levelObj in fileLevelData" :key="levelObj.value" :label="levelObj.label" :value="levelObj.value">
								</el-option>
							</el-select>
							<div class="el-form-item__error" style="top: 63%;left: 130px;" v-if="this.showLevelMsg == true">密级不能为空</div>
						</div>
						<div style="text-align: center;padding-top: 25px;">
							<el-button type="primary" style="width: 80px;" @click="saveFileSecretLevelDataClickFun">确定</el-button>
						</div>
					</el-form>
				</div>
			</el-dialog>

			<!-- 查看文件明细 -->
			<custom ref="voucher" v-bind:voucher="voucher"></custom>
		</div>
	</div>
</template>

<script>
import https, { fetchPost } from '../../../../https.js';
import voucher from '../common/custom.vue';
import accvoucher from '../common/accvoucher.vue';

export default {
	data() {
		return {
			currUserSecretLevel: '',	//	当前用户密级权限
			orivoucherpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
			accvoucherpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
			allvoucherpwm: {
				count: 0,
				limit: 10,
				page: 1,
				limits: [10, 20, 50, 100]
			},
			voucherViewTabs: '1',
			fileStatus: [],
			fileStatusImgList: JSON.parse(JSON.stringify(this.fileStatusList)),	//	文件状态 List
			oriVoucherFileStatusImgList: JSON.parse(JSON.stringify(this.fileStatusList)),	//	文件状态 List
			fileStatusDialogImgList: JSON.parse(JSON.stringify(this.fileStatusList)),	//	文件状态 List
			accVoucherFileStatusImgList: JSON.parse(JSON.stringify(this.fileStatusList)),	//	文件状态 List
			formatFileStatusImgList: JSON.parse(JSON.stringify(this.fileStatusList)),
			oriVoucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),
			oriVoucherDialogTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),
			formatOriVoucherTypeImgList: JSON.parse(JSON.stringify(this.originalvoucherTypeList)),
			formatAccVoucherTypeImgList: JSON.parse(JSON.stringify(this.accountingVoucherTypeList)),
			oriVoucherDataSearchName: '',
			accVoucherDataSearchName: '',
			currentRowIndex: '',	//	当前 index
			showColumn: false,
			oriVoucherTableData:[],
			accVoucherTableData: [],
			oriVoucherUploadInfoForm: {	//	原始凭证 查看详情-上传信息
				fileName: '',
				batchNo: '',
				fileNo: '',
				operator: '',
				importTime: '',
				importWay: '',
				year:'',
				opRecordList: []
			},
			accVoucherUploadInfoForm: {	//	记账凭证 查看详情-上传信息
				fileName: '',
				batchNo: '',
				fileNo: '',
				operator: '',
				importTime: '',
				importWay: '',
				opRecordList: []
			},
			advanceQueryDialogVisible: false,
			accQueryForm:{},
			oriQueryForm:{},
			archivesViewQueryForm: {
				pzhm: '',
				jshjStart: '',
				jshjEnd: '',
				pzrqStart: '',
				pzrqEnd: '',
				wjh: '',
				pch: '',
				scr: '',
				ywjm: '',
				scsjStart: '',
				scsjEnd: '',
				statusArr: "",
				processNo:""
			},
			showLevelMsg: false,
			fileLevelDialogVisible: false,
			fileLevelList: ['1', '2','3','4','5'],
			secretLevelForm: {
				count: 0,
				fileLevel: '',
				voucherIds: ''
			},
			fileLevelData: JSON.parse(JSON.stringify(this.secretLevelList)),
			viewDetailsGroupDialogVisible: false,
			viewDetailsVolumeDialogVisible: false,
			voucher: {
				vftype: '',	//	凭证类型：1：记账凭证 2：原始凭证
				vid: ''	//	凭证ID
			},
			imgBaseUrl: this.baseURL,
			tokenParam : "token=" + localStorage.getItem('token'),
			accvoucherId: '',	//	记账凭证ID
			previewFlag: false,	//	是否为点击预览操作
			pz_checked:true ,
			fiChecked:true,
			vh_checked:true,
			advanceVChecked:true,
			advanceChecked:true,

			selectOptions: [{
				value: 'DR',
				label: 'DR'
				}, {
				value: 'ST',
				label: 'ST'
				}, {
				value: 'RE',
				label: 'RE'
				}, {
				value: 'KG',
				label: 'KG'
				}
				],
			selectValue: ''
		};
	},
	components: {
		voucher,
		accvoucher
	},
	created: function() {
		// this.loadOriVoucherData();	//	加载原始凭证数据
		this.loadAccVoucherData();	//	加载记账凭证数据
	},
	methods: {
		refresh() {
			this.fuzzyQueryVoucherData();
		},
		handleSizeChange(pwmName, val) {
			this[pwmName].limit = val;
			if(this.voucherViewTabs == '1') {	//	记账凭证
				this.loadAccVoucherData();
			} else if(this.voucherViewTabs == '2') {	//	原始凭证
				this.loadOriVoucherData();
			}
		},
		handleCurrentChange(pwmName, val) {
			this[pwmName].page = val;
			if(this.voucherViewTabs == '1') {	//	记账凭证
				this.loadAccVoucherData();
			} else if(this.voucherViewTabs == '2') {	//	原始凭证
				this.loadOriVoucherData();
			}
		},
		clickRowByChecked(refTableName, row, column, event) {
			// this.$refs[refTableName].clearSelection();
			// this.currentRowIndex = row.rowIndex;
			if(refTableName == 'oriVoucherTable') {
				if(!column || column == undefined || (column && column.property != 'voucherNo')) {
					this.$refs[refTableName].toggleRowSelection(row);
				}
			} else {
				if(!column || column == undefined || (column && column.property != 'voucherNo')) {
					this.$refs[refTableName].toggleRowSelection(row);
				}
			}
			//	切换显示凭证详情
			if(this.voucherViewTabs == '1') {	//	记账凭证
				this.loadAccVoucherDetailData(row.id);
			} else if(this.voucherViewTabs == '2') {	//	原始凭证
				this.loadOriVoucherDetailData(row.id);
			}
		},
		showAccPopover() {
			this.previewFlag = true;
		},
		tableRowClassName({row, rowIndex}) {
			row.rowIndex = rowIndex;
		},
		upRow(refTableName) {	//	上翻
			let checkRows = this.$refs[refTableName].selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择数据进行上翻操作！');
				return;
			}
			let index = this.currentRowIndex;
			let pwmName = "";
			let voucherTableData = [];
			if(this.voucherViewTabs == '1') {
				pwmName = 'accvoucherpwm';
				voucherTableData = this.tableData;
			} else if(this.voucherViewTabs == '2') {
				pwmName = 'orivoucherpwm';
				voucherTableData = this.oriVoucherTableData;
			}
			if(this[pwmName].page == 1 && index == 0) {
				this.$message.error('当前已为第一个文件，无法上翻！');
				return;
			}
			let upData = [];
			if(index != 0) {	//	非第一页第一条数据
				upData = voucherTableData[index - 1];
				this.clickRowByChecked(refTableName, upData);
			} else {
				this.handleCurrentChange(this[pwmName].page - 1);
				if(this.voucherViewTabs == '1') {
					// upData = this.tableData[this.tableData.length - 1];
				} else if(this.voucherViewTabs == '2') {
					this.loadOriVoucherData().then((val) => {
						upData = this.oriVoucherTableData[this.oriVoucherTableData.length - 1];
						this.clickRowByChecked(refTableName, upData);
					});
				}
			}
		},
		downRow(refTableName) {	//	下翻
			let checkRows = this.$refs[refTableName].selection;
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择数据进行下翻操作！');
				return;
			}
			let index = this.currentRowIndex;
			let pwmName = "";
			let voucherTableData = [];
			if(this.voucherViewTabs == '1') {
				pwmName = 'accvoucherpwm';
				voucherTableData = this.tableData;
			} else if(this.voucherViewTabs == '2') {
				pwmName = 'orivoucherpwm';
				voucherTableData = this.oriVoucherTableData;
			}
			//	计算pageCount 分页总数
			let pageCount = Math.ceil(this[pwmName].count / this[pwmName].limit);
			if(this[pwmName].page == pageCount && index == voucherTableData.length - 1) {
				this.$message.error('当前已为最后一个文件，无法下翻！');
				return;
			}
			let downData = [];
			if(index != voucherTableData.length - 1) {	//	非当前页最后一条数据
				downData = voucherTableData[index + 1];
				this.clickRowByChecked(refTableName, downData);
			} else {
				this.handleCurrentChange(this[pwmName].page + 1);
				if(this.voucherViewTabs == '1') {
					// downData = this.tableData[0];
				} else if(this.voucherViewTabs == '2') {
					this.loadOriVoucherData().then((val) => {
						downData = this.oriVoucherTableData[0];
						this.clickRowByChecked(refTableName, upData);
					});
				}
			}
		},
		async getAccVoucherData() {	//	加载记账凭证头数据
			this.allvoucherpwm.param =  this.archivesViewQueryForm;
			this.allvoucherpwm.param.statusArr = this.fileLevelList.join(",");
			this.allvoucherpwm.limit = this.accvoucherpwm.limit;
			this.allvoucherpwm.page = this.accvoucherpwm.page;
			await fetchPost('/archival/getAccountVoucherHeaderList', this.allvoucherpwm).then(res => {
				if(res.data.success) {
					this.accVoucherTableData = res.data.data;
					this.accvoucherpwm.count = res.data.count;
				} else {
					this.$message.error(res.data.message);
				}
			}, error => {
				this.$message.error('加载记账凭证数据失败：' + error);
			});
		},
		async loadAccVoucherData() {	//	load accvoucher table
			this.getCheckVoucherCondition();
			this.getAccVoucherData().then(data => {
				if(this.accVoucherTableData && this.accVoucherTableData.length > 0) {
					//	默认选中第一条，并显示详情
					let firstData = this.accVoucherTableData[0];
					this.clickRowByChecked('accVoucherTable', firstData);
				}
			});
		},
		async loadAccVoucherDetailData(id) {	//	load 记账凭证详情
			this.$refs.voucher.getAccVoucherDetailDataById(id).then(accVoucherUploadData => {
				this.accVoucherUploadInfoForm = accVoucherUploadData;
				if(this.accVoucherUploadInfoForm.opRecordList && this.accVoucherUploadInfoForm.opRecordList.length > 0) {
					this.accVoucherUploadInfoForm.opRecordList.forEach(record => {
						//	format 时间
						record.opTime = this.timestampFormatter(record.opTime);
					});
				}
			});
		},
		async loadOriVoucherData() {	//	load orivoucher table
			this.getCheckVoucherCondition();
			this.getOriVoucherData().then(data => {
				if(this.oriVoucherTableData && this.oriVoucherTableData.length > 0) {
					//	默认选中第一条，并显示详情
					let firstData = this.oriVoucherTableData[0];
					this.clickRowByChecked('oriVoucherTable', firstData);
					// 显示详情
					// this.loadOriVoucherDetailData(firstData.id);
				}
			});
		},
		async getOriVoucherData() {	//	获取原始凭证数据
			this.allvoucherpwm.param =  this.archivesViewQueryForm;
			this.allvoucherpwm.param.statusArr = this.fileLevelList.join(",");
			this.allvoucherpwm.limit = this.orivoucherpwm.limit;
			this.allvoucherpwm.page = this.orivoucherpwm.page;
			await fetchPost('/archival/getOriginalVoucherList', this.allvoucherpwm).then(res => {
				if(res.data.success) {
					this.oriVoucherTableData = res.data.data;
					this.orivoucherpwm.count = res.data.count;
				} else {
					this.$message.error(res.data.message);
				}
			}, error => {
				this.$message.error('加载原始凭证数据失败：' + error);
			});
		},
		async loadOriVoucherDetailData(id) {	//	load 原始凭证详情
			this.$refs.voucher.getOriVoucherDetailDataById(id).then(oriVoucherUploadData => {
				this.oriVoucherUploadInfoForm = oriVoucherUploadData;
				if(this.oriVoucherUploadInfoForm.opRecordList && this.oriVoucherUploadInfoForm.opRecordList.length > 0) {
					this.oriVoucherUploadInfoForm.opRecordList.forEach(record => {
						record.opTime = this.timestampFormatter(record.opTime);
					});
				}
			});
		},
		fuzzyQueryVoucherData() {
			this.orivoucherpwm.limit = 10;
			this.orivoucherpwm.page = 1;
			this.accvoucherpwm.limit = 10;
			this.accvoucherpwm.page = 1;
			this.allvoucherpwm.limit = 10;
			this.allvoucherpwm.page = 1;
			if(this.voucherViewTabs == '1') {	//	记账凭证
				this.accvoucherpwm.likeSearch = this.accVoucherDataSearchName;
				this.allvoucherpwm.likeSearch = this.accVoucherDataSearchName;
				this.loadAccVoucherData();
			} else if(this.voucherViewTabs == '2') {	//	原始凭证
				this.orivoucherpwm.likeSearch = this.oriVoucherDataSearchName;
				this.allvoucherpwm.likeSearch = this.oriVoucherDataSearchName;
				this.loadOriVoucherData();
			}
		},
		advanceQuery() {	//	高级查询
			this.advanceQueryDialogVisible = true;
		},
		showVoucherImg(row, column, cell) {	//	查看按钮悬浮时显示凭证图像
			this.$refs['popover' + row.voucherNo].showPopover = true;
			// c = setTimeout(function() {
			// 	debugger
			// 	this.$refs['popover' + row.voucherNo].showPopover = true;
			// }, 2000);
		},
		closeVoucherImg(row, column, cell) {	//	查看按钮悬浮时显示凭证图像
			this.$refs['popover' + row.voucherNo].showPopover = false;
			// clearTimeout(c);
		},
		voucherTypeImgClickFun(event, index) { 	//	凭证类型点击选中/取消选中效果
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				this.oriVoucherTypeImgList[index].name = imgName + '-h';
			} else {
				this.oriVoucherTypeImgList[index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}

			let checkVoucherTypeList = [];
			this.oriVoucherTypeImgList.forEach(typeObj => {
				if(typeObj.name.substr(typeObj.name.length - 2) != '-h') {
					checkVoucherTypeList.push(typeObj.code);
				}
			});
			if(!checkVoucherTypeList || checkVoucherTypeList.length == 0) {
				this.$message.error('至少需要展示一个凭证类型！');
				this.oriVoucherTypeImgList[index].name = imgName;
				return false;
			}
			if(checkVoucherTypeList.length == 13){
				this.pz_checked = true;
			}else{
				this.pz_checked = false;
			}
			this.fuzzyQueryVoucherData();
			// this.loadOriVoucherData();
		},
		async getCheckVoucherCondition() {
			//	勾选的凭证类型
			let checkVoucherTypeList = [];
			if(this.voucherViewTabs == '2') {
				let voucherTypeImgList = this.oriVoucherTypeImgList;
				voucherTypeImgList.forEach(typeObj => {
					if(typeObj.name.substr(typeObj.name.length - 2) != '-h') {
						checkVoucherTypeList.push(typeObj.code);
					}
				});
			}

			//	勾选的文件状态
			let checkFileStatusList = [];
			let fileStatusImgList = [];
			if(this.voucherViewTabs == '1') {	//	记账凭证
				fileStatusImgList = this.accVoucherFileStatusImgList;
			} else if(this.voucherViewTabs == '2') {
				fileStatusImgList = this.oriVoucherFileStatusImgList;
			}
			fileStatusImgList.forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkFileStatusList.push(statusObj.code);
				}
			});

			if(this.voucherViewTabs == '1') {
				this.accvoucherpwm.search = { 'fileStatusList': checkFileStatusList.join(',') };
				this.allvoucherpwm.search = { 'fileStatusList': checkFileStatusList.join(',') };
			} else if(this.voucherViewTabs == '2') {
				this.orivoucherpwm.search = { 'voucherTypeList': checkVoucherTypeList.join(','), 'fileStatusList': checkFileStatusList.join(',') };
				this.allvoucherpwm.search = { 'voucherTypeList': checkVoucherTypeList.join(','), 'fileStatusList': checkFileStatusList.join(',') };
			}
		},
		fileStatusImgClickFun(event, index, fileStatusImgListName) {	//	文件状态点击选中/取消选中效果
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				this[fileStatusImgListName][index].name = imgName + '-h';
			} else {
				this[fileStatusImgListName][index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}

			//	勾选的文件状态
			let checkFileStatusList = [];
			this[fileStatusImgListName].forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkFileStatusList.push(statusObj.code);
				}
			});
			if(!checkFileStatusList || checkFileStatusList.length == 0) {
				this.$message.error('至少需要展示一个档案状态！');
				this[fileStatusImgListName][index].name = imgName;
				return false;
			}
			if(checkFileStatusList.length == 7){
				this.fiChecked = true;
			}else{
				this.fiChecked = false;
			}

			 if(this.voucherViewTabs == '1') {
				this.fuzzyQueryVoucherData();
				// this.loadAccVoucherData();
			} else if(this.voucherViewTabs == '2') {
				this.fuzzyQueryVoucherData();
				// this.loadOriVoucherData();
			}
		},
		updateFileLevelClickFun() {	//	文件密级修改
			this.showLevelMsg = false;
			let checkRows = [];
			if(this.voucherViewTabs == '1') {
				checkRows = this.$refs.accVoucherTable.selection;
			} else if(this.voucherViewTabs == '2') {
				checkRows = this.$refs.oriVoucherTable.selection;
			}
			if(!checkRows || checkRows.length == 0) {
				this.$message.warning('请选择需要密级修改的凭证文件！');
				return;
			}
			this.getUserSecretLevel().then(userLevel => {
				if(!userLevel) {
					this.$message.error('获取当前用户信息失败：用户未设置密级权限！');
					return;
				}
				this.currUserSecretLevel = userLevel;

				let voucherIdList = [];
				for (let i = 0; i < checkRows.length; i++) {
					const row = checkRows[i];
					//	用户无法修改密级权限比自身高的文件的密级权限。
					if(parseInt(userLevel) > parseInt(row.fileLevel)) {
						this.$message.error('不允许修改高于当前用户密级权限的文件！');
						return;
					}
					voucherIdList.push(row.id);
				}
				this.secretLevelForm.count = checkRows.length;
				this.secretLevelForm.voucherIds = voucherIdList.join(',');
				this.fileLevelDialogVisible = true;
			});
		},
		fileLevelSelectChange(val) {
			if(val) {
                this.showLevelMsg = false;
            }
		},
		saveFileSecretLevelDataClickFun() {
			let updateUrl = "";
			if(this.voucherViewTabs == '1') {
				updateUrl = '/archival/saveAccVoucherFileSecretLevelData';
			} else if(this.voucherViewTabs == '2') {
				updateUrl = '/archival/saveOriVoucherFileSecretLevelData';
			}
			if(!this.secretLevelForm.fileLevel) {
                this.showLevelMsg = true;
            } else {
                this.showLevelMsg = false;
            }
            if(!this.showLevelMsg) {
				//	 判断当前用户密级权限是否比修改后的档案密级权限低
				if(parseInt(this.secretLevelForm.fileLevel) < parseInt(this.currUserSecretLevel)) {
					this.$confirm('当前修改的密级权限比用户密级权限高，是否确认修改？', '提示', { type: 'warning' }).then(res => {
						this.saveFileSecretLevelData(updateUrl);
					});
				} else {
					this.saveFileSecretLevelData(updateUrl);
				}
			}
		},
		async saveFileSecretLevelData(url) {
			let params = this.secretLevelForm;
			await fetchPost(url, params).then(res => {
				if(res.data.success) {
					this.fileLevelDialogVisible = false;
					this.$message.success('文件密级修改成功！');
					if(this.voucherViewTabs == '1') {
						this.loadAccVoucherData();
					} else if(this.voucherViewTabs == '2') {
						this.loadOriVoucherData();
					}
				} else {
					this.$message.error('文件密级修改失败：' + res.data.message);
				}
			}, error => {
				this.$message.error('文件密级修改失败：' + error);
			});
		},
		deleteVoucherFileClickFun() {	//	删除凭证文件
			//	不支持删除 1、密级权限比当前用户高 2、文件状态为分组中，已分组，成册中，已成册
			let checkRows = [];
			if(this.voucherViewTabs == '1') {
				checkRows = this.$refs.accVoucherTable.selection;
			} else if(this.voucherViewTabs == '2') {
				checkRows = this.$refs.oriVoucherTable.selection;
			}
			if(!checkRows || checkRows.length == 0) {
				this.$message.error('请选择需要删除的凭证文件！');
				return;
			}
			let voucherIdList = [];
			let errorMsgList = [];
			for (let i = 0; i < checkRows.length; i++) {
				let msg = "";
				if(checkRows[i].fileStatus == '3' || checkRows[i].fileStatus == '4' || checkRows[i].fileStatus == '5' || checkRows[i].fileStatus == '6') {
					msg = "文件状态为分组中、已分组、成册中、已成册的凭证文件不支持删除！";
					if(errorMsgList.indexOf(msg) == -1) {
						errorMsgList.push(msg);
					}
				}
				if(this.currUserSecretLevel > checkRows[i].fileLevel) {
					msg = "不允许删除高于当前用户密级权限的文件！";
					if(errorMsgList.indexOf(msg) == -1) {
						errorMsgList.push(msg);
					}
				}
				voucherIdList.push(checkRows[i].id);
			}
			if(errorMsgList && errorMsgList.length > 0) {
				this.$message.error('不允许删除，具体错误原因：\n' + errorMsgList.join('\n'));
				return;
			}
			this.$confirm('是否删除选中凭证文件？', '删除', { type: 'warning' }).then(res => {
				this.deleteVoucherFile(voucherIdList.join(','));
			});
		},
		deleteVoucherFile(ids) {
			let deleteUrl = "";
			if(this.voucherViewTabs == '1') {
				deleteUrl = '/archival/deleteAccVoucherListById';
			} else if(this.voucherViewTabs == '2') {
				deleteUrl = '/archival/deleteOriVoucherListById';
			}
			fetchPost(deleteUrl, ids).then(res => {
				if(res.data.success) {
					this.$message.success('删除成功！');
					if(this.voucherViewTabs == '1') {
						this.loadAccVoucherData();
					} else if(this.voucherViewTabs == '2') {
						this.loadOriVoucherData();
					}
				} else {
					this.$message.error('删除失败：' + res.data.message);
				}
			}, error => {
				this.$message.error('删除失败：' + error);
			});
		},
		viewVoucherDetailsClickFun(rowData) {	// 查看操作
			if(rowData.fileLevel == '*') {
				return;
			}
			this.voucher.vftype = this.voucherViewTabs;	// 凭证类型
			this.voucher.vid = rowData.id;
			this.$refs.voucher.viewVoucherDetailsClickFun();
		},
		viewGroupDetailsClickFun(groupId) {	//	查看组信息
			this.$refs.voucher.viewGroupDetailsClickFun(groupId);
		},
		viewVolumeDetailsClickFun(bookId) {	//	查看册信息
			this.$refs.voucher.viewVolumeDetailsClickFun(bookId);
		},
		changePzAll(event){
			if(!event){
				this.pz_checked = false;
				this.oriVoucherTypeImgList.forEach(statusObj => {
					if(statusObj.code != '13'){
						if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
							statusObj.name = statusObj.name + '-h';
						}
					}
				});
			}else{
				this.pz_checked = true;
				this.oriVoucherTypeImgList.forEach(statusObj => {
					if(statusObj.name.substr(statusObj.name.length - 2) == '-h') {
						statusObj.name = statusObj.name.substr(0,statusObj.name.length - 2);
						console.log(statusObj.name)
					}
				});
			}
			this.getCheckVoucherCondition();
			this.loadOriVoucherData();
		},
		changeFiAll(event){
			if(!event){
				this.fiChecked = false;
				this.oriVoucherFileStatusImgList.forEach(statusObj => {
					if(statusObj.code != '13'){
						if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
							statusObj.name = statusObj.name + '-h';
						}
					}
				});
			}else{
				this.fiChecked = true;
				this.oriVoucherFileStatusImgList.forEach(statusObj => {
					if(statusObj.name.substr(statusObj.name.length - 2) == '-h') {
						statusObj.name = statusObj.name.substr(0,statusObj.name.length - 2);
					}
				});
			}
			this.getCheckVoucherCondition();
			this.loadOriVoucherData();
		},
		resetForm(formName){
			console.log(this.fileLevelList)
			this.archivesViewQueryForm =  {
				pzhm: '',
				jshjStart: '',
				jshjEnd: '',
				pzrqStart: '',
				pzrqEnd: '',
				wjh: '',
				pch: '',
				scr: '',
				ywjm: '',
				scsjStart: '',
				scsjEnd: '',
				sapType: '',
				processNo:""
			}
			this.fileLevelList = ['5']
		},
		voucherTypeImgDiglogClickFun(event, index) { 	//	凭证类型点击选中/取消选中效果
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				this.oriVoucherTypeImgList[index].name = imgName + '-h';
			} else {
				this.oriVoucherTypeImgList[index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}

			let checkVoucherTypeList = [];
			this.oriVoucherTypeImgList.forEach(typeObj => {
				if(typeObj.name.substr(typeObj.name.length - 2) != '-h') {
					checkVoucherTypeList.push(typeObj.code);
				}
			});
			if(!checkVoucherTypeList || checkVoucherTypeList.length == 0) {
				this.$message.error('至少需要展示一个凭证类型！');
				this.oriVoucherTypeImgList[index].name = imgName;
				return false;
			}
			if(checkVoucherTypeList.length == 13){
				this.pz_checked = true;
			}else{
				this.pz_checked = false;
			}
		},

		fileStatusImgDialogClickFun(event, index, fileStatusImgListName) {	//	文件状态点击选中/取消选中效果
			let imgObj = event.currentTarget;
			let imgName = imgObj.name;
			if((imgName.lastIndexOf('-h') + 2) != imgName.length) {
				this[fileStatusImgListName][index].name = imgName + '-h';
			} else {
				this[fileStatusImgListName][index].name = imgName.substr(0, imgName.lastIndexOf('-h'));
			}

			//	勾选的文件状态
			let checkFileStatusList = [];
			this[fileStatusImgListName].forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkFileStatusList.push(statusObj.code);
				}
			});
			if(!checkFileStatusList || checkFileStatusList.length == 0) {
				this.$message.error('至少需要展示一个档案状态！');
				this[fileStatusImgListName][index].name = imgName;
				return false;
			}
			if(checkFileStatusList.length == 7){
				this.fiChecked = true;
			}else{
				this.fiChecked = false;
			}
		},

		search(){
			console.log(this.voucherViewTabs)
			this.getCheckVoucherDiglogCondition();
			this.allvoucherpwm.param =  this.archivesViewQueryForm;
			this.allvoucherpwm.param.statusArr = this.fileLevelList.join(",");
			let url = '/archival/getOriginalVoucherList';
			if(this.voucherViewTabs == '1') {
				url = '/archival/getAccountVoucherHeaderList';
			}
			fetchPost(url, this.allvoucherpwm).then(res => {
				if(res.data.success) {
					if(this.voucherViewTabs == '1'){
						this.accVoucherTableData = res.data.data;
						this.accvoucherpwm.count = res.data.count;
					}else{
						this.oriVoucherTableData = res.data.data;
						this.orivoucherpwm.count = res.data.count;
					}
				} else {
					this.$message.error(res.data.message);
				}
			}, error => {
				this.$message.error('加载凭证数据失败：' + error);
			});
			this.advanceQueryDialogVisible =false;
		},


		async getCheckVoucherDiglogCondition() {
			//	勾选的凭证类型
			let checkVoucherTypeList = [];
			if(this.voucherViewTabs == '2') {
				let voucherTypeImgList = this.oriVoucherTypeImgList;
				voucherTypeImgList.forEach(typeObj => {
					if(typeObj.name.substr(typeObj.name.length - 2) != '-h') {
						checkVoucherTypeList.push(typeObj.code);
					}
				});
			}

			//	勾选的文件状态
			let checkFileStatusList = [];
			let fileStatusImgList = [];
			if(this.voucherViewTabs == '1') {	//	记账凭证
				fileStatusImgList = this.accVoucherFileStatusImgList;
			} else if(this.voucherViewTabs == '2') {
				fileStatusImgList = this.oriVoucherFileStatusImgList;
			}
			fileStatusImgList.forEach(statusObj => {
				if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
					checkFileStatusList.push(statusObj.code);
				}
			});

			if(this.voucherViewTabs == '1') {
				this.allvoucherpwm.search = { 'fileStatusList': checkFileStatusList.join(',') };
			} else if(this.voucherViewTabs == '2') {
				this.allvoucherpwm.search = { 'voucherTypeList': checkVoucherTypeList.join(','), 'fileStatusList': checkFileStatusList.join(',') };
			}
		},

		changeVhAll(event){
			if(!event){
				this.vh_checked = false;
				this.accVoucherFileStatusImgList.forEach(statusObj => {
					if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
						statusObj.name = statusObj.name + '-h';
					}
				});
			}else{
				this.vh_checked = true;
				this.accVoucherFileStatusImgList.forEach(statusObj => {
					if(statusObj.name.substr(statusObj.name.length - 2) == '-h') {
						statusObj.name = statusObj.name.substr(0,statusObj.name.length - 2);
					}
				});
			}
			this.getCheckVoucherCondition();
			this.loadAccVoucherData();
		},
		changeadvanceVAll(event){
			if(!event){
				this.advanceVChecked = false;
				this.pz_checked = false;
				this.oriVoucherTypeImgList.forEach(statusObj => {
					if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
						statusObj.name = statusObj.name + '-h';
					}
				});
			}else{
				this.advanceVChecked = true;
				this.pz_checked = true;
				this.oriVoucherTypeImgList.forEach(statusObj => {
					if(statusObj.name.substr(statusObj.name.length - 2) == '-h') {
						statusObj.name = statusObj.name.substr(0,statusObj.name.length - 2);
					}
				});
			}
		},
		advanceAll(event){
			if(this.voucherViewTabs == '1'){//记账凭证
				if(!event){
					this.advanceChecked = false;
					this.vh_checked = false;
					this.accVoucherFileStatusImgList.forEach(statusObj => {
						if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
							statusObj.name = statusObj.name + '-h';
						}
					});
				}else{
					this.advanceChecked = true;
					this.vh_checked = true;
					this.accVoucherFileStatusImgList.forEach(statusObj => {
						if(statusObj.name.substr(statusObj.name.length - 2) == '-h') {
							statusObj.name = statusObj.name.substr(0,statusObj.name.length - 2);
						}
					});
				}

			}else{//原始凭证
				if(!event){
					this.advanceChecked = false;
					this.fiChecked = false;
					this.oriVoucherFileStatusImgList.forEach(statusObj => {
						if(statusObj.code != '13'){
							if(statusObj.name.substr(statusObj.name.length - 2) != '-h') {
								statusObj.name = statusObj.name + '-h';
							}
						}
					});
				}else{
					this.advanceChecked = true;
					this.fiChecked = true;
					this.oriVoucherFileStatusImgList.forEach(statusObj => {
						if(statusObj.name.substr(statusObj.name.length - 2) == '-h') {
							statusObj.name = statusObj.name.substr(0,statusObj.name.length - 2);
						}
					});
				}
			}
		}

		
	},
	watch: {
		'voucherViewTabs': function(val) {
			let accForm = this.archivesViewQueryForm;
			if(val == '1') {
				this.accvoucherpwm.likeSearch = this.accVoucherDataSearchName;
				this.allvoucherpwm.likeSearch = this.accVoucherDataSearchName;
				this.oriQueryForm = this.archivesViewQueryForm;
				this.archivesViewQueryForm = this.accQueryForm;
				this.loadAccVoucherData();
			} else if(val == '2') {
				this.orivoucherpwm.likeSearch = this.oriVoucherDataSearchName;
				this.allvoucherpwm.likeSearch = this.oriVoucherDataSearchName;
				this.accQueryForm = this.archivesViewQueryForm;
				this.archivesViewQueryForm = this.oriQueryForm;
				this.loadOriVoucherData();
			}
		}
	}
};

</script>
<style scoped>
.table {
	width: 100%;
	font-size: 14px;
}
#archivesInv .el-main {
    padding: 0 0 0 0 !important;
}
.dialog-custom .el-dialog__body div{
	padding: -10px 0 0 10px !important;
}
.voucher-tag-title {
	font-size:14px;
	font-weight:bold;
	line-height: 25px;
    color: #66b1ff;
}
.voucher-tag-contmg {
	font-size: 12px;
	color:#909399;
}
/* form */
.my-container .ac-title {
	color: #606266;
	font-weight: bold;
}
.my-container .ac-form-label {
	text-align: right;
	line-height: 32px;
}
.my-container .ac-form-input{
	padding-left: 15px;
}
.my-container .ac-form-input span{
	line-height: 32px;
	text-align: center;
	padding: 0px 2px;
}
.container /deep/ .el-timeline-item__content {
    color: #606266 !important;
}
/deep/ .el-card__body {
    padding: 20px 0px 20px 15px !important;
}
/deep/ .el-timeline-item__wrapper {
    padding-left: 20px !important;
}
</style>